/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import PrivacyIcon from 'icons/PrivacyIcon';

const messages = defineMessages({
  title: {
    id: 'navigation.privacy-settings',
  },
});

const PrivacySettingsItem = () => (
  <RouteLinkItem
    iconBefore={PrivacyIcon}
    route="midas/my/privacy-settings"
    title={messages.title}
  />
);

export default PrivacySettingsItem;
